'use client';

import Maintenance from '@flipster/features/src/maintenance-page';
import { zendesk } from '@flipster/features/src/shared/zendesk/url';
import { IsomorphicLink } from '@flipster/react/design-utils/isomorphic-link';
import { css } from '@flipster/styled-system/css';
import { center, stack } from '@flipster/styled-system/patterns';
import { checkAxiosError } from '@flipster/utils/axios';

const ErrorMapper: Record<string, string> = {
  '403': 'Check your VPN connection',
};

export interface ErrorBoundaryProps {
  error: Error;
}

// global-error 는 layout, template 에러만 잡히는듯함 문서참고
const Error = ({ error }: ErrorBoundaryProps) => {
  const errorStatus = checkAxiosError(error) ? error.response?.status || '' : '';
  const isMaintenance = errorStatus === 503;

  if (isMaintenance) return <Maintenance />;

  //  여기 이하는 개발시와 stg 이하에만 보여야함
  if (errorStatus && ErrorMapper[errorStatus]) {
    return (
      <main className={stack({ h: '100vh', textAlign: 'center', justify: 'center' })}>
        <h1 className={css({ textStyle: 'Title/M', mb: 8, color: 'content.accent.sell' })}>{errorStatus}</h1>
        <p className={css({ textStyle: 'Text/L/Regular' })}>{ErrorMapper[errorStatus]}</p>
      </main>
    );
  }

  return (
    <main className={center({ h: '100vh', textStyle: 'Text/L/Regular', textAlign: 'center' })}>
      <p>
        We're experiencing a system issue that has temporarily restricted access.
        <br />
        If it continues, please{' '}
        <IsomorphicLink
          href={zendesk.getUrl('RequestNew')}
          className={css({ textStyle: 'Text/L/Underline', color: 'content.accent.info' })}
        >
          contact support.
        </IsomorphicLink>
      </p>
    </main>
  );
};

export default Error;
